import { useEffect, useState } from "react";
import { collection, orderBy, query } from "firebase/firestore";
import { useCollection } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { mapBoat } from "./mapBoat";

export const useBoats = () => {
  const [boats, setBoats] = useState([]);
  const [mapping, setMapping] = useState(false);
  const [value, loading, error] = useCollection(
    query(collection(db, "boats"), orderBy("createdAt", "desc"))
  );
  useEffect(() => {
    const run = async () => {
      setMapping(true);
      if (value) {
        const docs = value.docs.map((doc) => mapBoat(doc));
        setBoats(docs);
      } else {
        setBoats([]);
      }
      setMapping(false);
    };
    run();
  }, [value]);

  return { boats, loading: loading || mapping, error };
};
